import React from 'react'
import PropTypes from 'prop-types'
import {Form, Field} from 'simple-react-form'
import PlainText from 'App/components/fields/PlainText'
import styles from './styles.css'

export default class SearchBar extends React.Component {
  static propTypes = {
    searchBarText: PropTypes.string,
    setSearchBarText: PropTypes.func
  }

  render() {
    return (
      <div className={styles.container}>
        <Form state={this.props} onChange={changes => this.props.setSearchBarText(changes)}>
          <Field
            className={styles.searchField}
            placeholder={'Buscar'}
            fieldName="searchBarText"
            type={PlainText}
          />
        </Form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Exchange/Layout/Navbar/Markets/Menu/FilterBar/Mobile/SearchBar/index.js